import React from 'react'
import Api from '../services/ApiService'
import * as Bambora from '@bambora/checkout-sdk-web'

import Input from './InputComponent'
import Button from './ButtonComponent'
import LoadingScreen from './LoadingScreenComponent'
import {
    Typography,
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core'

export default class CustomerFormComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            status: 'ready',
            error: '',
            card: {},
            form: {
                termsAccepted: false,
                name: '',
                address: '',
                zipcode: '',
                city: '',
                country_code: '+45',
                telephone: '',
                email: ''
            },
            loadingScreen: {
                isLoading: false,
                text: ''
            },
            dialog: {
                isOpen: false
            }
        }

        this.handleDialogClick = this.handleDialogClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.paymentModal = this.paymentModal.bind(this)
    }

    paymentModal({ customer_id, resource_id, order_id, isExistingUser }) {
        this.setState({
            status: 'requesting_token',
            loadingScreen: {
                text: 'Indlæser betalingsvindue...'
            }
        })

        let room = this.props.selectedRoom

        Api.getPaymentToken({
            resource_id,
            customer_id,
            order_id,
            isExistingUser
        })
            .then(({ token }) => {
                let checkoutModal = new Bambora.ModalCheckout(token)

                checkoutModal.on(Bambora.Event.CardTypeResolve, card => {
                    this.setState({
                        card
                    })
                })

                checkoutModal.on(Bambora.Event.Cancel, () => {
                    this.setState({
                        status: 'ready'
                    })

                    Api.unlockBooking({ customer_id, order_id })
                })

                checkoutModal.on(Bambora.Event.Authorize, payload => {
                    checkoutModal.hide()

                    this.props.onPaymentComplete({
                        customer: this.state.form,
                        order: payload.data,
                        card: this.state.card,
                        startDate: this.props.startDate,
                        room
                    })

                    setTimeout(() => {
                        checkoutModal.destroy()
                    }, 2000)
                })

                checkoutModal.show()
            })
            .catch(error => {
                console.log('getPaymentToken() failed!')
            })
    }

    handleChange(event) {
        let { name: field, value } = event.target

        if (field === 'termsAccepted') {
            value = !this.state.form.termsAccepted
        }

        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [field]: value
            }
        }))
    }

    handleDialogClick(event) {
        event.preventDefault()
        getHTML('/', function(response) {
            console.log(response.getElementById('bookingTerms'))
        })
        this.setState(prevState => ({
            dialog: {
                ...prevState.dialog,
                isOpen: !this.state.dialog.isOpen
            }
        }))
    }

    handleSubmit(event) {
        event.preventDefault()

        let data = this.state.form
        let { resource_id } = this.props.selectedRoom

        this.setState({
            status: 'creating_booking',
            loadingScreen: {
                text: 'Registrerer oplysninger...'
            }
        })

        Api.createCustomer(data)
            .then(customer => {
                let { startDate } = this.props
                this.setState({
                    loadingScreen: {
                        text: 'Opretter booking ..'
                    }
                })
                return Api.createBooking({
                    resource_id: resource_id,
                    customer_id: customer.customer_id,
                    from_date: startDate.format('YYYY-MM-DD')
                }).then(booking => {
                    this.paymentModal({
                        customer_id: customer.customer_id,
                        resource_id: resource_id,
                        order_id: booking.order_id,
                        isExistingUser: false
                    })
                })
            })
            .catch(error => {
                error.json().then(json => {
                    this.setState({
                        status: 'ready',
                        error: json.message
                    })
                })
            })
    }

    render() {
        const { form, loadingScreen, status, error, dialog } = this.state
        const { config } = this.props

        return (
            <div>
                {status === 'ready' && (
                    <div>
                        <Typography
                            component="p"
                            style={{
                                color: '#F06F2F',
                                marginTop: 10,
                                marginBottom: 5,
                                fontWeight: 'bold'
                            }}
                        >
                            Dine oplysninger
                        </Typography>
                        <form
                            onSubmit={this.handleSubmit}
                            style={{ margin: 0 }}
                        >
                            <div>
                                <Input
                                    placeholder="Navn"
                                    name="name"
                                    onChange={this.handleChange}
                                    value={form.name}
                                    required
                                />
                            </div>
                            <div>
                                <Input
                                    placeholder="Adresse"
                                    name="address"
                                    onChange={this.handleChange}
                                    value={form.address}
                                    required
                                />
                            </div>
                            <div>
                                <Input
                                    placeholder="Postnummer"
                                    title="F.eks. 8000"
                                    name="zipcode"
                                    pattern="[0-9]{4}"
                                    onChange={this.handleChange}
                                    value={form.zipcode}
                                    required
                                />
                            </div>
                            <div>
                                <Input
                                    placeholder="By"
                                    name="city"
                                    onChange={this.handleChange}
                                    value={form.city}
                                    required
                                />
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Input
                                    type="tel"
                                    placeholder="+45"
                                    title="F.eks. +45 eller +47"
                                    name="country_code"
                                    pattern="^\+[0-9]{1,3}$"
                                    onChange={this.handleChange}
                                    value={form.countryCode}
                                    style={{
                                        width: '80px',
                                        marginRight: '10px'
                                    }}
                                    required
                                />
                                <Input
                                    placeholder="Telefon"
                                    title="F.eks. 23456789"
                                    name="telephone"
                                    type="tel"
                                    pattern="[0-9]+"
                                    onChange={this.handleChange}
                                    value={form.telephone}
                                    required
                                />
                            </div>
                            <div>
                                <Input
                                    placeholder="Email"
                                    name="email"
                                    type="email"
                                    onChange={this.handleChange}
                                    value={form.email}
                                    required
                                />
                                {error && (
                                    <Typography
                                        component="p"
                                        style={{
                                            marginTop: '1em',
                                            color: 'red'
                                        }}
                                    >
                                        Der eksisterer allerede en kunde med
                                        denne emailadresse. Log venligst ind som
                                        eksisterende kunde for at fortsætte din
                                        bestilling.
                                    </Typography>
                                )}
                            </div>
                            <div
                                style={{
                                    marginTop: 40,
                                    marginBottom: -10,
                                    float: 'left',
                                    width: '100%',
                                    position: 'relative',
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <label
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontFamily: 'Montserrat, sans-serif',
                                        alignSelf: 'flex-end',
                                        lineHeight: 1,
                                        display: 'flex'
                                    }}
                                >
                                    <input
                                        style={{
                                            cursor: 'pointer',
                                            margin: '2px 10px 0 0'
                                        }}
                                        type="checkbox"
                                        checked={form.termsAccepted}
                                        name="termsAccepted"
                                        onChange={this.handleChange}
                                    />
                                    <a href={config.terms_url} target="_blank"><span>Jeg har læst og accepterer handelsbetingelserne</span></a>
                                </label>
                                <Button
                                    type="submit"
                                    disabled={!form.termsAccepted}
                                >
                                    Bestil
                                </Button>
                            </div>
                            {dialog.isOpen && (
                                <Dialog open onClose={this.handleDialogClick}>
                                    <DialogTitle>
                                        Handelsbetingelser
                                    </DialogTitle>
                                    <DialogContent>
                                        <Typography></Typography>
                                    </DialogContent>
                                </Dialog>
                            )}
                        </form>
                    </div>
                )}
                {status !== 'ready' && (
                    <LoadingScreen text={loadingScreen.text} height="300" />
                )}
            </div>
        )
    }
}

var getHTML = function(url, callback) {
    if (!window.XMLHttpRequest) return
    var xhr = new XMLHttpRequest()

    xhr.onload = function() {
        if (callback && typeof callback === 'function') {
            callback(this.responseXML)
        }
    }

    // Get the HTML
    xhr.open('GET', url)
    xhr.responseType = 'document'
    xhr.send()
}



// WEBPACK FOOTER //
// ./src/components/CustomerFormComponent.jsx